import React, { useCallback } from "react";
import { Tooltip } from "@material-ui/core";
import FormFieldBox from "../DesignSystem/formFieldBox";
import Dropdown from "../DesignSystem/dropdown";
import Input from "../DesignSystem/input";
import Textarea from "../DesignSystem/textarea";
import InfoIcon from "../../assets/images/info-icon.svg";

interface BandwidthBoxProps {
  bandwidthDescription: string;
  linksError: string;
  noOfLinksToAdd: number | string;
  portTypeOptions: any[];
  tempPortTypeId: any;
  onPortTypeChange: (portTypeId: number) => void;
  onBandwidthDescriptionChange: (_: any) => void;
  onNoOfLinksChange: (_: any) => void;
  onKeypress: (_: any) => void;
}

const BandwidthBox: React.FC<BandwidthBoxProps> = ({
  bandwidthDescription,
  linksError,
  noOfLinksToAdd,
  tempPortTypeId,
  portTypeOptions,
  onPortTypeChange,
  onBandwidthDescriptionChange,
  onNoOfLinksChange,
  onKeypress,
}) => {
  const handlePortTypeChange = useCallback(
    (value: any) => {
      onPortTypeChange(parseInt(value));
    },
    [onPortTypeChange]
  );

  return (
    <div className="box bandwidth">
      <div className="form-root-1">
        <div className="bottom-form-root">
          <FormFieldBox excludeMarginBottom>
            <div className="no-of-links-root">
              <div>
                <label>
                  No. of Links
                  <span className="asterisk">*</span>
                </label>
                <Tooltip
                  classes={{
                    tooltip: "tooltip",
                  }}
                  title="Enter the integer number of links to be added which share a common description."
                  arrow
                  placement="right"
                >
                  <img src={InfoIcon} alt="Info" />
                </Tooltip>
              </div>
              <div>
                <Input
                  variant="number"
                  name="no-of-links"
                  min={1}
                  value={noOfLinksToAdd}
                  className="no-of-links-input"
                  errorMessageClass="small-fonts"
                  onChange={onNoOfLinksChange}
                  onKeypress={onKeypress}
                  error={!!linksError}
                  errorMessage=""
                />
              </div>
            </div>
          </FormFieldBox>
          <FormFieldBox excludeMarginBottom>
            <div className="no-of-links-root">
              <div>
                <label>
                  Type
                  <span className="asterisk">*</span>
                </label>
                <Tooltip
                  classes={{
                    tooltip: "tooltip",
                  }}
                  title="Choose the Port Interface Type."
                  arrow
                  placement="right"
                >
                  <img src={InfoIcon} alt="Info" />
                </Tooltip>
              </div>
              <div>
                <Dropdown
                  className="ne-select"
                  icon="icon"
                  value={tempPortTypeId || portTypeOptions[0]?.id}
                  valueKey="id"
                  textKey="port_type"
                  options={portTypeOptions}
                  onChange={handlePortTypeChange}
                />
              </div>
            </div>
          </FormFieldBox>
        </div>
        <FormFieldBox>
          <div className="text-area-root" style={{ paddingTop: "32px" }}>
            <div>
              <label>Link Description</label>
              <Tooltip
                classes={{
                  tooltip: "tooltip",
                }}
                title="Enter a description which applies to link being added."
                arrow
                placement="right"
              >
                <img src={InfoIcon} alt="Info" />
              </Tooltip>
            </div>
            <div style={{maxHeight: '52px'}}>
              <Textarea
                value={bandwidthDescription}
                className="bandwidth-description test-max"
                name="bandwidth-description"
                onChange={onBandwidthDescriptionChange}
                onKeypress={onKeypress}
              />
            </div>
          </div>
        </FormFieldBox>
      </div>
      <div style={{ height: "50px" }} />
    </div>
  );
};

export default BandwidthBox;
